<template>
  <div class="mx-auto flex justify-between py-5 px-12 min-[1440px]:px-0 items-center w-full max-w-[1140px] text-white">
    <a href="/" aria-label="Homepage">
      <Logo aria-hidden="true" :title="`${brandName} logo`" class="h-10 w-auto" />
    </a>
    <div class="flex gap-6 h-10">
      <TrustPilotRating
        v-if="showTrustPilot"
        :brand-name="brandName"
        :trustpilotLink="trustpilotLink"
        :image-host="imageHostUrl"
        :score="trustPilotScore"
        colour-scheme="light"
        text-size="medium"
        score-variant="score-out-of-five"
        :with-score-out-of-five="false"
        logo-sizing="extra-small"
        stars-sizing="navbar"
        variant="navbar"
      />
      <div class="min-w-[343px] flex">
        <SearchBar variant="navbar" />
      </div>
      <a class="flex items-center gap-2 w-full" :href="props.content.callLinkContent.href">
        <div class="h-8 w-8 rounded-full border-[1.5px] border-white p-[7px]">
          <Call aria-hidden="true" class="h-full w-full" />
        </div>
        <span>{{ props.content.callLinkContent.number }}</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import TrustPilotRating from "../../Reviews/components/TrustPilot/TrustPilotRating.vue";
import SearchBar from "../../SearchBar/SearchBar.vue";
import type { DRXNavigationContent } from "../types";
import MedexpressLogo from "../../../resources//logos/medexpress-logo.svg?inline";
import ZiphealthLogo from "../../../resources/logos/ziphealth-logo.svg?inline";
import Call from "../../../resources/call.svg?inline";

const props = defineProps<{
  showTrustPilot: boolean;
  trustPilotScore: number;
  imageHostUrl: string;
  brandName: string;
  content: DRXNavigationContent;
}>();

const logos = {
  medexpress: MedexpressLogo,
  ziphealth: ZiphealthLogo,
};

const Logo = logos[props.brandName];

const trustpilotLinks = {
  medexpress: "https://uk.trustpilot.com/review/www.medexpress.co.uk",
  ziphealth: "https://us.trustpilot.com/review/www.ziphealth.co",
};

const trustpilotLink = trustpilotLinks[props.brandName];
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
